import CityPageTemplate from "../city-template/CityPageTemplate";
import { danvilleConfig } from "./data";

export default function DanvillePage() {
  return <CityPageTemplate config={danvilleConfig} />;
}